import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
const opts = { namespace: NAV_DRAWER };
/**
 * Base Component Side Navigation
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let BaseSideNav = class BaseSideNav extends Vue {
    untoggleNestedMenusChanged(val) {
        if (val) {
            this.onSingleMenuClick();
        }
    }
    /**
     * Close v-list-group component upon clicking single menu
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.16.0}
     *
     * @return {void}
     */
    onSingleMenuClick() {
        const menus = this.$refs.nestedMenu;
        if (Array.isArray(menus)) {
            this.$refs.nestedMenu.forEach((menu) => {
                // Invoke v-list-group toggle() function to close nested menus
                menu.toggle();
            });
        }
    }
};
__decorate([
    Getter('untoggleNestedMenus', opts)
], BaseSideNav.prototype, "untoggleNestedMenus", void 0);
__decorate([
    Mutation('untoggleNestedMenus', opts)
], BaseSideNav.prototype, "closeGroupedMenus", void 0);
__decorate([
    Prop({ required: true })
], BaseSideNav.prototype, "menuItems", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseSideNav.prototype, "orangeTheme", void 0);
__decorate([
    Watch('untoggleNestedMenus')
], BaseSideNav.prototype, "untoggleNestedMenusChanged", null);
BaseSideNav = __decorate([
    Component
], BaseSideNav);
export default BaseSideNav;
